module.exports = __webpack_public_path__ + "static/media/web logos_DigiL_colour.b193492b.jpg";